var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingNotificationActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55664 17.5C8.70293 17.7533 8.91332 17.9637 9.16668 18.11C9.42003 18.2563 9.70743 18.3333 9.99997 18.3333C10.2925 18.3333 10.5799 18.2563 10.8333 18.11C11.0866 17.9637 11.297 17.7533 11.4433 17.5",
    stroke: "#1450FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.71846 12.7717C2.60959 12.8911 2.53775 13.0394 2.51167 13.1988C2.48559 13.3582 2.50639 13.5218 2.57155 13.6696C2.6367 13.8174 2.7434 13.943 2.87867 14.0313C3.01394 14.1196 3.17194 14.1666 3.33346 14.1667H16.6668C16.8283 14.1668 16.9863 14.1199 17.1217 14.0318C17.257 13.9437 17.3639 13.8182 17.4292 13.6705C17.4945 13.5228 17.5155 13.3593 17.4897 13.1999C17.4638 13.0405 17.3921 12.892 17.2835 12.7726C16.1751 11.6301 15.0001 10.4159 15.0001 6.66675C15.0001 5.34067 14.4733 4.0689 13.5357 3.13121C12.598 2.19353 11.3262 1.66675 10.0001 1.66675C8.67404 1.66675 7.40227 2.19353 6.46459 3.13121C5.52691 4.0689 5.00012 5.34067 5.00012 6.66675C5.00012 10.4159 3.82429 11.6301 2.71846 12.7717Z",
    stroke: "#1450FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingNotificationActiveIcon);
export default __webpack_public_path__ + "static/media/SettingNotificationActiveIcon.39b7344b0ffcdac4ec80a7ebd4a1813d.svg";
export { ForwardRef as ReactComponent };